<template>
  <v-flex xs12 px-3 style="padding-top: 10px !important;" class="main">
    <v-flex xs12 style="overflow-y: hidden;">
      <v-btn @click="gotoFrontPage" style="width: 50px;" class="breadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="startCreatePallet" class="breadCrumb">
        Create pallet
      </v-btn>
      <v-btn @click="selectSupplier(currentSupplier)" v-if="currentSupplier" class="breadCrumb">
        {{ currentSupplier.name }}
      </v-btn>
    </v-flex>
    <v-flex xs12 v-if="showSupplierList && suppliersLoaded && suppliers.length === 0">
      <div style="padding: 50px; text-align: center; font-weight: bold; font-size: 20px; width: 100%;">No suppliers found</div>
    </v-flex>
    <v-container fluid py-2 px-3 v-show="showSupplierList" class="supplierButtons">
      <v-layout style="max-height: calc(100vh - 190px);">
        <v-flex xs12 style="overflow-y: auto;">
          <v-flex xs12 v-for="(supplier, i) in suppliers" :key="i" :style="'height: ' + Math.min(20, Math.max(6, 65 / suppliers.length)) + 'vh; margin-bottom: ' + (Math.max(0.5, 8 / suppliers.length)) + 'vh !important;'" class="supplierButton">
            <v-btn @click="selectSupplier(supplier)" :style="'width: 100%; height: ' + Math.min(20, Math.max(6, 65 / suppliers.length)) + 'vh !important; max-height: 30vh !important; font-size: ' + Math.min(Math.max(50 - (5 * suppliers.length), 14), 25) + 'pt !important;'"><v-icon :style="supplierIconStyle(supplier)">error</v-icon>{{ supplier.name }}</v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid pa-0 v-if="showPallet" class="palletListContainer palletContainer">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex style="overflow-y: auto;">
          <div v-if="categoriesLoaded && categories.length === 0" style="padding: 50px; text-align: center; font-weight: bold; font-size: 20px;">No label reports found for supplier</div>
          <Panel :title="'Pallet' + (currentPallet.externalNumber ? ' #' + currentPallet.externalNumber : '')" no-margin="true" class="palletPanel" v-if="categoriesLoaded && categories.length">
            <v-flex xs12 pa-2>
              <table style="margin-left: 10px;">
                <tr>
                  <td style="padding-right: 60px;" class="header">Pallet number</td>
                  <td>
                    <div class="palletNumberInput" @click="openPalletNumberDialog">{{ currentPallet.externalNumber }}</div>
                  </td>
                </tr>
                <tr>
                  <td style="padding-right: 60px; padding-top: 10px;" class="header">&frac12; pallet</td>
                  <td style="padding-top: 12px;">
                    <v-checkbox color="teal" v-model="currentPallet.half" style="margin-left: -2px; padding-top: 0 !important;"></v-checkbox>
                  </td>
                </tr>
              </table>
            </v-flex>
            <v-flex xs12 pa-2 style="padding-top: 20px !important;">
              <table class="palletItems">
                <tr>
                  <th style="width: 50px;" v-if="currentPallet.items.length > 1"></th>
                  <th style="width: 80px;" v-if="showColorColumn(currentPallet)">Color</th>
                  <th style="width: 50px;" v-if="showImageColumn(currentPallet)"></th>
                  <th>Category</th>
                  <th style="width: 100px;">Amount</th>
                </tr>
                <tr v-for="(item, i) in currentPallet.items" v-bind:key="item.id">
                  <td v-if="currentPallet.items.length > 1">
                    <v-icon v-if="currentPallet.items.length > 1" @click="confirmDeletePalletItem(i)" title="Delete">delete</v-icon>
                  </td>
                  <td v-if="showColorColumn(currentPallet)">
                    <div v-if="item.category && item.category.id > 0 && !(item.category.color.secondColor && item.category.color.secondColor !== '')" :style="'width: 25px; height: 25px; background-color: #' + item.category.color.color + '; border: 1px solid #cccccc; display: table-cell;'"></div>
                    <div v-if="item.category && item.category.id > 0 && item.category.color.secondColor && item.category.color.secondColor !== ''" :style="'width: 25px; height: 25px; background: repeating-linear-gradient(-45deg, #' + item.category.color.color + ', #' + item.category.color.color + ' 3px, #' + item.category.color.secondColor + ' 3px, #' + item.category.color.secondColor + ' 6px); border: 1px solid #cccccc; display: table-cell;'"></div>
                  </td>
                  <td v-if="showImageColumn(currentPallet)">
                    <v-icon v-if="item.category && item.category.image" class="tag" @click="showCategoryImage(item.category.image)">fa-tag</v-icon>
                  </td>
                  <td>
                    <table class="noPadding category">
                      <tr>
                        <td :style="'width: 100%;'">
                          <div class="categoryInput" v-if="categories.length > 0">
                            <v-select :items="categories" v-model="item.category" return-object>
                              <template slot="selection" slot-scope="data">
                                <div class="category" style="padding-top: 10px;">{{ data.item.displayLabel }}</div>
                              </template>
                              <template slot="item" slot-scope="data">
                                <div class="category">{{ data.item.displayLabel }}</div>
                              </template>
                            </v-select>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td style="padding-right: 20px; padding-top: 10px;">
                    <div class="amountInput" @click="openAmountDialog(item)">{{ item.amount ? item.amount : '' }}</div>
                  </td>
                </tr>
              </table>
              <v-dialog v-model="palletNumberDialog" width="70vh" content-class="numberPadDialog" attach=".palletPanel">
                <div class="numberPadDialogContainer">
                  <table class="numberPad" style="width: 100%;">
                    <tr>
                      <td colspan="3"><div class="numberPadValue">{{ currentPallet.externalNumber }}</div></td>
                      <td rowspan="5" class="wide"><div class="saveAmountBtn" @click="closePalletNumberDialog"><v-icon>done</v-icon></div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="palletNumberClick(1)">1</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(2)">2</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(3)">3</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="palletNumberClick(4)">4</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(5)">5</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(6)">6</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="palletNumberClick(7)">7</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(8)">8</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(9)">9</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="clearPalletNumber()">Clr</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(0)">0</div></td>
                      <td><div class="numberBtn" @click="backspacePalletNumber()"><v-icon style="color: #DDDDDD; font-size: 5vh;">keyboard_backspace</v-icon></div></td>
                    </tr>
                  </table>
                </div>
              </v-dialog>
              <v-dialog v-model="amountDialog" width="70vh" content-class="numberPadDialog" attach=".palletPanel" persistent>
                <div class="numberPadDialogContainer">
                  <table class="numberPad" style="width: 100%;">
                    <tr>
                      <td colspan="3"><div class="numberPadValue">{{ currentItem.amount ? currentItem.amount : '' }}</div></td>
                      <td rowspan="5" class="wide"><div class="saveAmountBtn" @click="closeAmountDialog"><v-icon>done</v-icon></div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="numberClick(1)">1</div></td>
                      <td><div class="numberBtn" @click="numberClick(2)">2</div></td>
                      <td><div class="numberBtn" @click="numberClick(3)">3</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="numberClick(4)">4</div></td>
                      <td><div class="numberBtn" @click="numberClick(5)">5</div></td>
                      <td><div class="numberBtn" @click="numberClick(6)">6</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="numberClick(7)">7</div></td>
                      <td><div class="numberBtn" @click="numberClick(8)">8</div></td>
                      <td><div class="numberBtn" @click="numberClick(9)">9</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="clear()">Clr</div></td>
                      <td><div class="numberBtn" @click="numberClick(0)">0</div></td>
                      <td><div class="numberBtn" @click="backspace()"><v-icon style="color: #DDDDDD; font-size: 5vh;">keyboard_backspace</v-icon></div></td>
                    </tr>
                  </table>
                </div>
              </v-dialog>
            </v-flex>
            <v-flex xs12 sm5 text-xs-left>
              <div class="palletButtonsLeft">
                <v-btn @click="addPalletItem()" class="addCategory" style="margin-left: 10px !important;">Add category</v-btn>
              </div>
            </v-flex>
            <v-flex xs12 sm7 text-xs-right>
              <div class="createPalletButton">
                <v-btn :disabled="!canSavePallet" @click="savePallet(false)">Save pallet</v-btn>
                <v-btn :disabled="!canSavePallet" @click="savePallet(true)">Save pallet and create new</v-btn>
                <v-btn @click="gotoFrontPage">Cancel</v-btn>
              </div>
            </v-flex>
          </Panel>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="confirmDeletePalletItemDialog" attach=".palletContainer" width="450px" v-if="showPallet">
      <v-card pa-5>
        <v-card-title class="headline">Delete category</v-card-title>
        <v-card-text>Are you sure you want to delete this category?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="deletePalletItem" class="bw-3">Yes</v-btn>
          <div style="width: 10px;"></div>
          <v-btn flat @click="confirmDeletePalletItemDialog = false" class="bw-3">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div style="background-color: rgba(0, 0, 0, 0.25); position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;" @click="showCategoryImageDialog = false" v-if="showCategoryImageDialog">
      <img :src="categoryImageUrl" style="max-width: 80%; max-height: 80%; border: 5px solid white; border-radius: 5px;"/>
    </div>
    <ErrorDialog ref="errorDialog"/>
  </v-flex>
</template>

<script>
import Panel from './Panel'
import PalletItems from './PalletItems'
import ProductionOverview from './ProductionOverview.vue'
import DateUtil from '@/assets/javascript/dateutil'
import NumberUtil from '@/assets/javascript/numberutil'
import ErrorDialog from '../components/ErrorDialog'
import axios from 'axios'
import uuid from 'uuid/v4'

export default {
  name: 'TodoCreatePallet',
  components: { Panel, PalletItems, ProductionReport: ProductionOverview, ErrorDialog },
  data () {
    return {
      suppliers: null,
      suppliersLoaded: false,
      currentSupplier: null,
      categories: null,
      categoriesLoaded: false,
      currentPallet: null,
      palletNumberDialog: false,
      currentItem: {},
      itemIndex: null,
      amountDialog: false,
      showCategoryImageDialog: false,
      categoryImageUrl: '',
      confirmDeletePalletItemDialog: false
    }
  },
  created: function () {
    this.startCreatePallet()
    document.addEventListener('keydown', this.keydownHandler)
  },
  destroyed: function () {
    document.removeEventListener('keydown', this.keydownHandler)
  },
  computed: {
    showSupplierList: function () {
      return !this.currentSupplier
    },
    showPallet: function () {
      return !this.showSupplierList && this.currentPallet
    },
    isConnected: function () {
      return this.$store.getters['session/isConnected'] && this.isOnline
    },
    hasPalletItems: function () {
      return this.currentPallet && this.currentPallet.items && this.currentPallet.items.length > 0
    },
    canSavePallet: function () {
      if (!this.currentPallet.externalNumber || this.currentPallet.externalNumber === '') {
        return false
      }
      for (let item of this.currentPallet.items) {
        if (!item.category) {
          return false
        }
        if (!NumberUtil.isPositiveInteger(item.amount)) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    showMessage (message) {
      this.$parent.$parent.showMessage(message)
    },
    loadSuppliers: function () {
      this.suppliersLoaded = false
      axios.get('/backend/rest/supplier/create_pallet')
        .then(response => {
          this.suppliers = response.data
          this.suppliersLoaded = true
          if (this.suppliers && this.suppliers.length === 1) {
            this.selectSupplier(this.suppliers[0])
          }
        })
        .catch(() => {
        })
    },
    loadCategories: function () {
      this.categoriesLoaded = false
      this.categories = []
      axios.get('/backend/rest/category/supplier/' + this.currentSupplier.id + '/create_pallet')
        .then(response => {
          this.categories = response.data
          this.categoriesLoaded = true
        })
        .catch(() => {
        })
    },
    gotoFrontPage: function () {
      this.currentSupplier = null
      this.currentField = null
      this.currentPallet = null
      this.$parent.$parent.gotoHome()
    },
    startCreatePallet: function () {
      this.currentSupplier = null
      this.currentField = null
      this.currentPallet = null
      this.loadSuppliers()
    },
    selectSupplier: function (supplier) {
      this.currentSupplier = supplier
      this.loadCategories()
      this.createNewPallet()
    },
    openPalletNumberDialog: function () {
      this.palletNumberDialog = true
    },
    closePalletNumberDialog: function () {
      this.palletNumberDialog = false
    },
    openAmountDialog: function (item) {
      this.currentItem = item
      this.amountDialog = true
    },
    closeAmountDialog: function () {
      this.amountDialog = false
    },
    numberClick: function (number) {
      let value = this.currentItem.amount
      if (value === null) {
        value = 0
      }
      value = value + '' + number
      this.currentItem.amount = Number(value)
    },
    clear: function () {
      this.currentItem.amount = 0
    },
    backspace: function () {
      let val = '' + this.currentItem.amount
      if (val.length > 1) {
        let value = val.substring(0, val.length - 1)
        this.currentItem.amount = Number(value)
      } else {
        this.clear()
      }
    },
    palletNumberClick: function (number) {
      let value = this.currentPallet.externalNumber
      if (value === null) {
        value = 0
      }
      value = value + '' + number
      this.currentPallet.externalNumber = '' + Number(value)
    },
    clearPalletNumber: function () {
      this.currentPallet.externalNumber = ''
    },
    backspacePalletNumber: function () {
      let val = '' + this.currentPallet.externalNumber
      if (val.length > 1) {
        let value = val.substring(0, val.length - 1)
        this.currentPallet.externalNumber = '' + Number(value)
      } else {
        this.clearPalletNumber()
      }
    },
    supplierIconStyle: function (supplier) {
      let color = null
      if (supplier.firstPickupDate) {
        let minutesToDeadline = DateUtil.minutesToDate(supplier.firstPickupDate)
        if (minutesToDeadline < (24 * 60)) {
          color = '#FF6666'
        } else if (minutesToDeadline < (48 * 60)) {
          color = '#FFBB66'
        }
      }
      if (color) {
        return 'font-size: 36px; color: ' + color + '; margin-right: 15px; font-size: 120%;'
      }
      return 'width: 0; color: transparent;'
    },
    createNewPallet: function () {
      this.currentPallet = {
        id: 0,
        supplier: {
          id: this.currentSupplier.id,
          number: this.currentSupplier.number
        },
        externalNumber: '',
        half: false,
        items: []
      }
      this.addPalletItem()
    },
    savePallet: function (createNew) {
      let pallet = JSON.parse(JSON.stringify(this.currentPallet))
      axios.post('/backend/rest/pallet/create_for_supplier', pallet)
        .then(response => {
          console.log('Got response: ' + response)
          this.showMessage('Pallet ' + pallet.externalNumber + ' created')
          if (createNew) {
            this.createNewPallet()
          } else {
            this.gotoFrontPage()
          }
        })
        .catch(error => {
          let errorMessage = 'Failed to save pallet'
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }
          console.log(errorMessage)
          this.$nextTick(() => {
            this.$refs.errorDialog.errorTitle = 'Error'
            this.$refs.errorDialog.errorMessage = 'Failed to save pallet.<br/>Please check your connection and try again.'
            this.$refs.errorDialog.errorDialog = true
          })
          // this.errorMessage = errorMessage
        })
    },
    addPalletItem: function () {
      let nextId = 0
      if (this.currentPallet.items && this.currentPallet.items.length > 0) {
        nextId = -this.currentPallet.items.length
      }
      let item = {
        id: nextId,
        uuid: uuid(),
        category: null,
        categoryName: '',
        plannedAmount: 0,
        amount: 0,
        manual: true
      }
      this.currentPallet.items.push(item)
    },
    confirmDeletePalletItem (index) {
      this.itemIndex = index
      this.confirmDeletePalletItemDialog = true
    },
    deletePalletItem: function () {
      if (this.currentPallet.items.length > 1 && this.itemIndex < this.currentPallet.items.length) {
        let items = this.currentPallet.items
        items.splice(this.itemIndex, 1)
        this.currentPallet.items = items
      }
      this.confirmDeletePalletItemDialog = false
    },
    showColorColumn: function (pallet) {
      if (pallet.items && pallet.items.length > 0) {
        for (let i in pallet.items) {
          if (pallet.items[i].category && pallet.items[i].category.id > 0) {
            return true
          }
        }
      }
      return false
    },
    showImageColumn: function (pallet) {
      if (pallet.items && pallet.items.length > 0) {
        for (let i in pallet.items) {
          if (pallet.items[i].category && pallet.items[i].category.id > 0 && pallet.items[i].category.image) {
            return true
          }
        }
      }
      return false
    },
    showCategoryImage: function (imageUuid) {
      this.categoryImageUrl = '/backend/image/' + imageUuid
      this.showCategoryImageDialog = true
    },
    keydownHandler: function (event) {
      if (this.amountDialog) {
        if (event.key >= '0' && event.key <= '9') {
          this.numberClick(Number(event.key))
        } else if (event.key === 'Backspace') {
          this.backspace()
        } else if (event.key === 'Delete') {
          this.clear()
        } else if (event.key === 'Enter') {
          this.closeAmountDialog()
        }
      } else if (this.palletNumberDialog) {
        if (event.key >= '0' && event.key <= '9') {
          this.palletNumberClick(Number(event.key))
        } else if (event.key === 'Backspace') {
          this.backspacePalletNumber()
        } else if (event.key === 'Delete') {
          this.clearPalletNumber()
        } else if (event.key === 'Enter') {
          this.closePalletNumberDialog()
        }
      } else {
        if (event.key === '+') {
          this.addPalletItem()
        }
      }
    }
  },
  watch: {
  }
}
</script>

<style scoped>
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .header {
    font-size: 16px;
    font-weight: bold;
  }
  .palletItems {
    width: 100%;
    font-size: 10pt;
    border-collapse: collapse;
  }
  .palletItems td {
    border-top: 1px solid #DDDDDD;
    padding: 10px 5px;
  }
  .palletItems th {
    text-align: left;
    padding: 2px 5px;
    color: #606060;
    font-size: 14px;
  }
  .contractorAmount {
    font-size: 15px !important;
  }
  .palletButtonsLeft .v-btn.back {
    border-radius: 8px;
    height: 50px !important;
    width: 125px;
    font-size: 20px !important;
  }
  .palletButtonsLeft .v-btn.addCategory {
    border-radius: 8px;
    height: 50px !important;
    width: 190px;
    font-size: 20px !important;
  }
  .createPalletButton .v-btn {
    border-radius: 8px;
    height: 50px !important;
    font-size: 20px !important;
    margin-left: 8px !important;
    padding: 0 30px;
  }
  .startPalletButton .v-btn,
  .endPalletButton .v-btn {
    border-radius: 8px;
    height: 50px !important;
    width: 240px;
    font-size: 20px !important;
  }
  .saveItemButton .v-btn {
    border-radius: 8px;
    height: 50px !important;
    width: 75px;
    min-width: 40px !important;
    padding: 0;
  }
  .saveItemButton .v-btn .v-icon {
    font-size: 36px !important;
  }
  .palletNumberInput {
    border: 1px solid #004d40;
    border-radius: 5px;
    height: 40px;
    width: 200px;
    cursor: pointer;
    font-size: 20px;
    line-height: 40px;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .amountInput {
    border: 1px solid #004d40;
    border-radius: 5px;
    height: 40px;
    width: 75px;
    cursor: pointer;
    font-size: 20px;
    line-height: 40px;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .categoryInput {
    border: 1px solid #004d40;
    border-radius: 5px;
    height: 40px;
    width: 90%;
    cursor: pointer;
    font-size: 20px;
    line-height: 40px;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .v-text-field>.v-input__control>.v-input__slot:after {
    border-color: currentcolor;
    border-style: solid;
    border-width: 5px;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
  }
  .readonly {
    cursor: default !important;
  }
  .numberPadDialog {
    box-shadow: none;
  }
  .numberPad {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
  }
  .numberPad tr {
    border: none;
  }
  .numberPad tr td {
    border: none;
    padding: 2px;
    text-align: right;
    width: 22%;
  }
  .numberPad tr td.wide {
    width: 34%;
  }
  .numberBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .numberBtn:hover {
    background-color: rgba(0, 62, 48, 0.87);
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .tabletBtn {
    width: 100%;
    height: 50px;
    text-align: center;
    vertical-align: center;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    background-color: #003d30;
    border-radius: 5px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .tabletBtn:hover {
    background-color: rgba(0, 62, 48, 0.87);
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .numberPadValue {
    border: 1px solid #004d40;
    border-radius: 10px;
    height: 10vh;
    width: 100%;
    cursor: pointer;
    font-size: 7vh;
    line-height: 10vh;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .saveAmountBtn {
    width: 100%;
    height: 52.5vh;
    text-align: center;
    vertical-align: center;
    padding-top: 20vh;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .saveAmountBtn .v-icon {
    font-size: 10vh;
    color: rgb(221, 221, 221);
  }
  .palletListContainer .v-btn {
    border-radius: 5px;
  }
  .v-dialog__content .v-btn {
    border-radius: 5px !important;
  }
  .tag {
    color: #004d40;
    cursor: pointer;
  }
  table.category {
    width: 100%;
  }
  table.category tr td {
    border: none;
    padding: 0 10px 0 0;
  }
  div.categoryButtonHeader {
    padding: 5px 48px 0 24px;
    background-color: #003d30;
    border-radius: 5px;
    height: 42px;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  div.categoryButtonHeader table {
    width: 100%;
    font-size: 110%;
    font-weight: bold;
    color: white;
  }
  div.category {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoCreatePallet.vue